import axios from 'axios';
import config from '../config';

const { url } = config;

console.log('url', url);

const Api = axios.create({
  baseURL: url + 'api/',
  withCredentials: true,
});

axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded';

export default Api;
